import { get } from '@/api/train-change'
import { make } from 'vuex-pathify'
import orderBy from 'lodash.orderby'

const state = {
  all: {},
  active: null,
  pending: false,
  inited: false
}

const mutations = make.mutations(state)

const actions = {
  async fetch({ commit }, params) {
    commit('SET_INITED', true)
    commit('SET_PENDING', true)
    const { data } = await get(params)

    commit(
      'SET_ALL',
      data.reduce((acc, value) => {
        acc[value._id] = value
        return acc
      }, {})
    )

    commit('SET_ACTIVE', data[0] ? data[0]._id : null)
    commit('SET_PENDING', false)
  }
}

const getters = {
  allList: state =>
    orderBy(
      Object.values(state.all),
      [order => order.metadata.messagedatetime],
      ['desc']
    )
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
